//@flow
import * as React from 'react';
import {baseClass} from "../../../../pages/UiKit/newUiKit/utilities/baseClass";
import type {id, onClick} from "../../../../services/flowTypes/appFlowTypes";
import type {addClasses} from "../../../../services/flowTypes/uiKitFlowTypes";
import './BtnBack.css';
import HoveredIcon from "../../../composed/HoveredIcon/HoveredIcon";
import baseIconSrc from "./../../../../assets/btn-arrow-back.svg";
import hoveredIconSrc from "./../../../../assets/btn-arrow-back-active.svg";

type Props = {
  id?: id,
  addClasses?: addClasses,
  onClick: onClick,
  label?: string
};
//TODO: fix test
const BtnBack = (props: Props) => {
  return (
    <div type="button" id={props.id} onClick={props.onClick}
         className={baseClass("BtnBack", props.addClasses)}>
        <HoveredIcon baseIconSrc={baseIconSrc} hoveredIconSrc={hoveredIconSrc}/>
      {props.label && <div className="BtnBackLabel">{props.label}</div>}
    </div>
  );
};

export default BtnBack;